<mat-list>
  <mat-list-item>
    <sn-icon matListIcon>beenhere</sn-icon>
    <div matLine>{{ camera?.name }}</div>
    <div matLine class="fs-text-secondary">Name</div>
  </mat-list-item>

  <mat-list-item *ngIf="camera?.model && camera?.make">
    <sn-icon matListIcon>build</sn-icon>
    <div matLine>{{ camera?.model }} / {{ camera?.make }}</div>
    <div matLine class="fs-text-secondary">Model/Make</div>
  </mat-list-item>

  <mat-list-item>
    <sn-icon matListIcon></sn-icon>
    <div matLine>{{ camera?.type }}</div>
    <div matLine class="fs-text-secondary">Control</div>
  </mat-list-item>

  <mat-list-item>
    <sn-icon matListIcon></sn-icon>
    <div matLine>{{ camera?.disposition }}</div>
    <div matLine class="fs-text-secondary">Disposition</div>
  </mat-list-item>

  <mat-list-item>
    <sn-icon matListIcon>gps_fixed</sn-icon>
    <div matLine>{{ camera?.geometry | geometryToString }}</div>
    <div matLine class="fs-text-secondary">Coordinates</div>
  </mat-list-item>

  <mat-list-item *ngIf="camera?.location">
    <sn-icon matListIcon>location_city</sn-icon>
    <div matLine>{{ camera?.location.name }}</div>
    <div matLine class="fs-text-secondary">Location</div>
  </mat-list-item>

  <mat-list-item *ngIf="camera?.floor">
    <sn-icon matListIcon>layers</sn-icon>
    <div matLine>{{ camera?.floor.name }}</div>
    <div matLine class="fs-text-secondary">Floor</div>
  </mat-list-item>

  <mat-list-item class="tag-list" *ngIf="camera.tags.length || camera.canEdit">
    <sn-icon matListIcon>local_offer</sn-icon>
    <sn-tag-edit-list
      matLine
      [contentType]="'Camera'"
      [tags]="camera.tags"
      [canChange]="camera.canEdit"
      (tagsChanged)="onTagsChanged($event)"
    >
    </sn-tag-edit-list>
  </mat-list-item>
</mat-list>
